module.exports = __webpack_public_path__ + "img/dep_drinks@2x.cebbe2e2.png";